import { render, staticRenderFns } from "./LogoHeadRow.vue?vue&type=template&id=3dd2ca0a&scoped=true"
import script from "./LogoHeadRow.vue?vue&type=script&lang=js"
export * from "./LogoHeadRow.vue?vue&type=script&lang=js"
import style0 from "./LogoHeadRow.vue?vue&type=style&index=0&id=3dd2ca0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd2ca0a",
  null
  
)

export default component.exports